import { render, staticRenderFns } from "./WarningProfileMinor.vue?vue&type=template&id=f5586682"
import script from "./WarningProfileMinor.vue?vue&type=script&lang=js"
export * from "./WarningProfileMinor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports